import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ExternalLinkService {
  URLs = {
    getExternalApps: '/getExternalApps',
  };

  constructor(private http: HttpClient) {}

  getExternalApplications(baseUrl: string) {
    const clientKey = sessionStorage.getItem('client_key') || '';
    const headers = new HttpHeaders({ client_key: clientKey });
    return this.http
      .get(`${baseUrl}${this.URLs.getExternalApps}`, {
        headers,
        withCredentials: true,
      })
      .pipe(map((res: any) => (Array.isArray(res?.data) ? res.data : [])));
  }
}
